<template>
  <div id="pageProperty">
    <a-tabs :animated="false" :activeKey="activeTab" @change="changeTabs" @click="handleResize">
      <a-tab-pane :tab="$t('projectQueryList')" key="project">
        <a-row class="pageProperty-btn" type="flex" justify="start">
          <a-col>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("generic.Refresh") }}</span>
              </template>
              <img style="margin-left: 10px;" @click="iniFreshTable(true)" class="sbxs" src="../../../assets/img/ss-refresh.png"  width="22" height="22">
            </a-tooltip>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('generic.Add') }}</span>
              </template>
              <img @click="addRowData()" style="margin-left: 10px;" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
            </a-tooltip>
            <a-popconfirm
                    title="Are you sure delete this task?"
                    @confirm="deleteData()"
                    okText="Yes"
                    cancelText="No"
            >
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t("generic.Delete") }}</span>
                </template>
                <img style="margin: 0 10px" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
              </a-tooltip>
            </a-popconfirm>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("generic.Up") }}</span>
              </template>
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="arrow-up"
                      style="background: #719844;border:none"
                      @click="arrowUp"
              ></a-button>
            </a-tooltip>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("generic.Down") }}</span>
              </template>
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="arrow-down"
                      style="background: #ef4b12;border:none"
                      @click="arrowDown"
              ></a-button>
            </a-tooltip>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("publicLang.Save") }}</span>
              </template>
              <img @click="saveSort" class="sbxs" src="../../../assets/img/ss-save.png"  width="22" height="22">
            </a-tooltip>
          </a-col>
          <a-col style="height: 24px;margin-left: 20px;font-weight: bold;">
            {{$t('generic.Project')}}:
            <a-select
                    style="width: 400px;margin-left: 10px;"
                    size="small"
                    @change="changeProject"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    show-search
                    v-model="projectCode">
              <a-select-option v-for="item in projectCodeList" :value="item.projectCode">{{ item.projectCode }} -- {{ item.displayName }}</a-select-option>
            </a-select>
          </a-col>
          <a-col>
            <a-button size="small" type="primary" @click="showCopyProject" style="margin-left: 10px;">{{$t('copyToAnotherProject')}}</a-button>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane :tab="$t('defaultQueryList')" key="default">
        <a-row class="pageProperty-btn" type="flex" justify="start">
          <a-col>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("generic.Refresh") }}</span>
              </template>
              <img style="margin-left: 10px;" @click="iniFreshTable(true)" class="sbxs" src="../../../assets/img/ss-refresh.png"  width="22" height="22">
            </a-tooltip>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('generic.Add') }}</span>
              </template>
              <img @click="addRowData()" style="margin-left: 10px;" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
            </a-tooltip>
            <a-popconfirm
                    title="Are you sure delete this task?"
                    @confirm="deleteData()"
                    okText="Yes"
                    cancelText="No"
            >
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t("generic.Delete") }}</span>
                </template>
                <img style="margin: 0 10px" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
              </a-tooltip>
            </a-popconfirm>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("generic.Up") }}</span>
              </template>
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="arrow-up"
                      style="background: #719844;border:none"
                      @click="arrowUp"
              ></a-button>
            </a-tooltip>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("generic.Down") }}</span>
              </template>
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="arrow-down"
                      style="background: #ef4b12;border:none"
                      @click="arrowDown"
              ></a-button>
            </a-tooltip>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t("publicLang.Save") }}</span>
              </template>
              <img @click="saveSort" class="sbxs" src="../../../assets/img/ss-save.png"  width="22" height="22">
            </a-tooltip>
            <a-button size="small" type="primary" @click="copyToProjectList" style="margin-left: 10px;">{{$t('copyToProjectList')}}</a-button>
          </a-col>
        </a-row>
      </a-tab-pane>
    </a-tabs>
    <div ref="refListTop">
      <a-table :rowSelection="{selectedRowKeys: selectedRowKeys,onChange: onSelectChange}"
               style="overflow-y: auto;"
               :style="'height:' + windowHeight + 'px'"
               :scroll="{ y: windowHeight - 60,x: 'max-content'}"
               ref="tableRef"
               :dataSource="queryConditionList"
               :columns="columns"
               bordered
               :pagination="false"
               :rowKey="record => record.seq"
               size="small"
               :loading="loading"
               :locale="tabelText">
        <img slot="operation" slot-scope="text" @click="editRowData(text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
      </a-table>
    </div>
    <a-modal
            :title="$t('generic.Add')"
            v-model="showAdd"
            width="50%"
            :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="saveAddData" size="small">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="addForm">
        <a-row>
          <a-col :span="12">
            <a-form-item :label="$t('queryTable')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['moduleCodeQueryName',{rules: [{ required: true, message: 'Required'}]}]"
                      @change="(value) => queryNameModule(value, true)"
              >
                <a-select-option v-for="(item, index) in moduleList.subModuleCode" :value="item" :key="index">
                  {{ item }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="$t('queryFieldName')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                        'queryName',
                        {rules: [{ required: true, message: 'Required', type:'array'}]}
                        ]"
                      @change="selectQueryTable"
                      mode="multiple"
              >
                <a-select-option
                        v-for="(item, index) in queryNameList"
                        :value="item.FIELD_NAME"
                        :key="index"
                >{{ item.FIELD_NAME }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-show="showJoinLine">
          <a-col :span="12">
            <a-form-item :label="$t('detailTable')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['moduleCodeDetailJoinName']"
                      @change="(value) => detailJoinNameModule(value, true)"
              >
                <a-select-option v-for="(item, index) in moduleList.subModuleCode" :value="item" :key="index">
                  {{ item }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="$t('detailJoinFieldName')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      showSearch
                      size="small"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['detailJoinName',]"
                      @change="selectDetailTable"
              >
                <a-select-option
                        v-for="(item, index) in detailJoinNameList"
                        :value="item.FIELD_NAME"
                        :key="index"
                >{{ item.FIELD_NAME }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-show="showJoinLine">
          <a-col :span="12">
            <a-form-item :label="$t('headerTable')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['moduleCodeHeaderJoinName']"
                      @change="(value) => headerJoinNameModule(value, true)"
              >
                <a-select-option v-for="(item, index) in moduleList.subModuleCode" :value="item" :key="index">
                  {{ item }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="$t('headerJoinFieldName')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['headerJoinName',]"
                      @change="selectHeaderTable"
              >
                <a-select-option
                        v-for="(item, index) in headerJoinNameList"
                        :value="item.FIELD_NAME"
                        :key="index"
                >{{ item.FIELD_NAME }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('pageType')" v-bind="formItemLayout">
              <a-select
                      :placeholder="$t('publicLang.PleaseSelect')"
                      style="width: 100%"
                      size="small"
                      showSearch
                      allowClear
                      @change="selectedPageType"
                      v-decorator="[
                  'pageType',
                  {
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              >
                <a-select-option v-for="item in pageTypeSelect" :value="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('compareType')" v-bind="formItemLayout">
              <a-select
                      :placeholder="$t('publicLang.PleaseSelect')"
                      style="width: 100%;"
                      size="small"
                      showSearch
                      allowClear
                      @change="selectedCompareType"
                      v-decorator="[
                        'compareType',
                        {
                          rules: [{ required: true, message: 'Required' }]
                        }
                      ]"
              >
                <a-select-option v-for="item in compareTypeSelect" :value="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="showCodeMasterGroup">
          <a-col :span="19">
            <a-form-item :label="$t('codeMasterGroup')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['codeMasterGroup',{
                        rules: [{ required: true, message: 'Required' }]
                      }]"
              >
                <a-select-option
                        v-for="(item, index) in codeGroupList"
                        :value="item.CODE_GROUP"
                        :key="index"
                >{{ item.CODE_GROUP }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="showFixedValue">
          <a-col :span="19">
            <a-form-item :label="$t('fixedValue')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"v-decorator="['fixedValue',{rules: [{ required: true, message: 'Required' }]}]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('userlang.englishName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'englishName', { rules: [{ required: true, message: 'Required' }] }]"
              />
            </a-form-item>
          </a-col>
          <!--          <a-col :span="1" style="margin-left: 5px;margin-top: 3px;">-->
          <!--            <a-button type="primary" size="small" @click="copyNameToAnother">{{ $t('copyToAnotherLanguage') }}</a-button>-->
          <!--          </a-col>-->
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('userlang.sumplifiedName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'simplifiedName', { rules: [{ required: true, message: 'Required' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('userlang.traditionalName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'traditionalName', { rules: [{ required: true, message: 'Required' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('userlang.koreanName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'koreanName', { rules: [{ required: true, message: 'Required' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('thaiName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'thaiName', { rules: [{ required: true, message: 'Required' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('japaneseName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'japaneseName', { rules: [{ required: true, message: 'Required' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
            :title="$t('generic.Editable')"
            v-model="showEdit"
            width="50%"
            :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="saveEditData" size="small">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="editForm">
        <a-row>
          <a-col :span="20" v-show="false">
            <a-form-item label="UID" v-bind="formItemLayout">
              <a-input placeholder="UID" autocomplete="off" size="small" style="width: 100%" v-decorator="['uid',{ initialValue: editData.uid }]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11" v-if="isAddData">
            <a-form-item :label="$t('queryTable')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['moduleCodeQueryName',{rules: [{ required: true, message: 'Required'}],initialValue:this.editData.querySubModuleCode}]"
                      @change="(value) => queryNameModule(value, true)"
              >
                <a-select-option v-for="(item, index) in moduleList.subModuleCode" :value="item" :key="index">
                  {{ item }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="isAddData ? 11 : 19">
            <a-form-item :label="$t('queryFieldName')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      size="small"
                      :disabled="!isAddData"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                        'queryName',
                        {
                          rules: [{ required: true, message: 'Required',type: 'array'}],initialValue: editData.queryName == null ? null : editData.queryName.split(',')
                        }
                        ]"
                      mode="multiple"
                      @change="selectQueryTable"
              >
                <a-select-option
                        v-for="(item, index) in queryNameList"
                        :value="item.FIELD_NAME"
                        :key="index"
                >{{ item.FIELD_NAME }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-show="showJoinLine">
          <a-col :span="11">
            <a-form-item :label="$t('detailTable')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['moduleCodeDetailJoinName',{initialValue:editData.detailSubModuleCode}]"
                      @change="(value) => detailJoinNameModule(value, true)"
              >
                <a-select-option v-for="(item, index) in moduleList.subModuleCode" :value="item" :key="index">
                  {{ item }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item :label="$t('detailJoinFieldName')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      size="small"
                      allowClear
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                        'detailJoinName',
                        {initialValue: editData.detailJoinName}
                        ]"
                      @change="selectDetailTable"
              >
                <a-select-option
                        v-for="(item, index) in detailJoinNameList"
                        :value="item.FIELD_NAME"
                        :key="index"
                >{{ item.FIELD_NAME }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-show="showJoinLine">
          <a-col :span="11">
            <a-form-item :label="$t('headerTable')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['moduleCodeHeaderJoinName',{initialValue:editData.headerSubModuleCode}]"
                      @change="(value) => headerJoinNameModule(value, true)"
              >
                <a-select-option v-for="(item, index) in moduleList.subModuleCode" :value="item" :key="index">
                  {{ item }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item :label="$t('headerJoinFieldName')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      size="small"
                      allowClear
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="[
                        'headerJoinName',
                        {initialValue: editData.headerJoinName}
                        ]"
                      @change="selectHeaderTable"
              >
                <a-select-option
                        v-for="(item, index) in headerJoinNameList"
                        :value="item.FIELD_NAME"
                        :key="index"
                >{{ item.FIELD_NAME }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('pageType')" v-bind="formItemLayout">
              <a-select
                      :placeholder="$t('publicLang.PleaseSelect')"
                      style="width: 100%"
                      size="small"
                      @change="selectedPageType"
                      showSearch
                      v-decorator="['pageType',{initialValue: editData.pageType,rules: [{ required: true, message: 'Required' }]}]"
              >
                <a-select-option v-for="item in pageTypeSelect" :value="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <a-form-item :label="$t('compareType')" v-bind="formItemLayout">
              <a-select
                      :placeholder="$t('publicLang.PleaseSelect')"
                      style="width: 100%"
                      size="small"
                      showSearch
                      @change="selectedCompareType"
                      v-decorator="['compareType',{initialValue: editData.compareType,rules: [{ required: true, message: 'Required' }]}]"
              >
                <a-select-option v-for="item in compareTypeSelect" :value="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="showCodeMasterGroup">
          <a-col :span="19">
            <a-form-item :label="$t('codeMasterGroup')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      allowClear
                      size="small"
                      showSearch
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-decorator="['codeMasterGroup',{initialValue: editData.codeMasterGroup,rules: [{ required: true, message: 'Required' }]}]"
              >
                <a-select-option
                        v-for="(item, index) in codeGroupList"
                        :value="item.CODE_GROUP"
                        :key="index"
                >{{ item.CODE_GROUP }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="showFixedValue">
          <a-col :span="19">
            <a-form-item :label="$t('fixedValue')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%" v-decorator="['fixedValue',{initialValue: editData.fixedValue,rules: [{ required: true, message: 'Required' }]}]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" v-if="isAddData">
            <a-form-item :label="$t('userlang.englishName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'englishName', { rules: [{ required: true, message: 'Required'}],initialValue: editData.englishName }]"
              />
            </a-form-item>
          </a-col>
          <!--          <a-col :span="1" v-if="isAddData" style="margin-left: 5px;margin-top: 3px;">-->
          <!--            <a-button type="primary" size="small" @click="copyNameToAnother">{{ $t('copyToAnotherLanguage') }}</a-button>-->
          <!--          </a-col>-->
        </a-row>
        <a-row>
          <a-col :span="19" v-if="isAddData">
            <a-form-item :label="$t('userlang.sumplifiedName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'simplifiedName', { rules: [{ required: true, message: 'Required' }],initialValue: editData.simplifiedName }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" v-if="isAddData">
            <a-form-item :label="$t('userlang.traditionalName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'traditionalName', { rules: [{ required: true, message: 'Required' }],initialValue: editData.traditionalName }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" v-if="isAddData">
            <a-form-item :label="$t('userlang.koreanName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'koreanName', { rules: [{ required: true, message: 'Required' }],initialValue: editData.koreanName }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" v-if="isAddData">
            <a-form-item :label="$t('thaiName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'thaiName', { rules: [{ required: true, message: 'Required' }],initialValue: editData.thaiName }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" v-if="isAddData">
            <a-form-item :label="$t('japaneseName')" v-bind="formItemLayout">
              <a-input :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width: 100%"
                       v-decorator="[ 'japaneseName', { rules: [{ required: true, message: 'Required' }],initialValue: editData.japaneseName }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
            :title="$t('copyTo')"
            v-model="showProject"
            width="50%"
            :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="copyToNewProject" size="small">{{ $t('generic.Copy') }}</a-button>
      </template>
      <a-row>
        <a-form :form="projectForm">
          <a-col style="height: 24px;font-weight: bold;">
            <a-form-item :label="$t('generic.Project')" v-bind="formItemLayout">
              <a-select
                      style="width: 400px;"
                      size="small"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      show-search
                      v-decorator="['newProjectCode',{rules: [{ required: true, message: 'Required'}]}]"
              >
                <a-select-option v-for="item in projectCodeList.filter(item => item.projectCode != projectCode)" :value="item.projectCode">
                  {{ item.projectCode }} -- {{ item.displayName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import { throttle } from 'lodash';
  export default {
    props: {
      pagedbSelectList: {
        type: Array,
        default: function() {
          return [];
        }
      },
      selectedModuleCode: {
        type: String,
        default: function() {
          return '';
        }
      }
    },
    data() {
      return {
        addForm: this.$form.createForm(this),
        editForm: this.$form.createForm(this),
        projectForm: this.$form.createForm(this),
        maskClosable: false, // 取消点击遮罩取消
        tabelText: {
          emptyText: "No record found"
        }, // table 编辑内容
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 8 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 }
          }
        },
        showAdd: false,
        showEdit: false,
        selectedRowKeys: [], // table check选下标
        checkRows: [], // table 选中的list
        queryConditionList: [], // table data
        loading: false, // table loading
        editData: {}, // 编辑当条数据
        moduleList: [],
        allModuleList: {//T_GE_MODULE表数据
          VASN://Generic Master头部列表Module列
                  {
                    moduleCode:"ASN",
                    subModuleCode:[
                      "ASN_HEADER","ASN_DETAIL","ASN_SHIPMENT","ASN_PARTNER"
                    ]
                  },
          VSO:
                  {
                    moduleCode:"SO",
                    subModuleCode:[
                      "SO_HEADER","SO_DETAIL","SO_SHIPMENT","SO_PARTNER"
                    ]
                  },
          INV_ENQ:
                  {
                    moduleCode:"INV_ENQ",
                    subModuleCode:[
                      "INV_ENQ"
                    ]
                  },
        },
        codeGroupList: [],
        schemaUid:'',
        headerJoinNameList:[],
        detailJoinNameList:[],
        queryNameList:[],
        queryTableName:"",
        headerTableName:"",
        detailTableName:"",
        isAddData:false,
        showCodeMasterGroup:false,
        showFixedValue:false,
        searchProject:"",
        projectCodeList:[],
        projectCode: '', // project 下拉选中的值
        tempProjectCode:'',
        activeTab:'project',
        windowHeight: 0,
        pageTypeSelect:[
          {key:'Input',value:'Input'},
          {key:'Dropdown',value:'Dropdown'},
          {key:'Switch',value:'Switch'},
          {key:'TextArea',value:'TextArea'},
          {key:'Date',value:'Date'},
          {key:'DateTime',value:'DateTime'}
        ],
        compareTypeSelect:[],
        compareTypeData:{
          Input:[
            {key:'=',value:'='},
            {key:'like',value:'like'},
            {key:'<>',value:'<>'},
            {key:'>',value:'>'},
            {key:'<',value:'<'},
            {key:'>=',value:'>='},
            {key:'<=',value:'<='},
          ],
          Dropdown:[
            {key:'=',value:'='},
            {key:'<>',value:'<>'},
            {key:'in',value:'in'},
            {key:'not in',value:'not in'}
          ],
          Switch:[
            {key:'=',value:'='},
            {key:'like',value:'like'},
            {key:'<>',value:'<>'},
            {key:'>',value:'>'},
            {key:'<',value:'<'},
            {key:'>=',value:'>='},
            {key:'<=',value:'<='},
            {key:'in',value:'in'},
            {key:'not in',value:'not in'},
            {key:'is empty',value:'is empty'},
            {key:'is not empty',value:'is not empty'}
          ],
          TextArea:[
            {key:'in',value:'in'},
            {key:'not in',value:'not in'}
          ],
          Date:[
            {key:'=',value:'='},
            {key:'<>',value:'<>'},
            {key:'>',value:'>'},
            {key:'<',value:'<'},
            {key:'>=',value:'>='},
            {key:'<=',value:'<='}
          ],
          DateTime:[
            {key:'=',value:'='},
            {key:'<>',value:'<>'},
            {key:'>',value:'>'},
            {key:'<',value:'<'},
            {key:'>=',value:'>='},
            {key:'<=',value:'<='}
          ],
        },
        showProject:false,
        showJoinLine:false,//显示关联字段行(Header Join Table,Header Join Name,Detail Join Table,Detail Join Name)
      };
    },
    computed: {
      columns(){
        return [
          {
            title: this.$t('queryFieldName'),
            dataIndex: "queryName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "queryName" }
          },
          {
            title: this.$t('pageType'),
            dataIndex: "pageType",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "pageType" }
          },
          {
            title: this.$t('compareType'),
            dataIndex: "compareType",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "compareType" }
          },
          {
            title: this.$t('fixedValue'),
            dataIndex: "fixedValue",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "fixedValue" }
          },
          {
            title: this.$t('codeMasterGroup'),
            dataIndex: "codeMasterGroup",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "codeMasterGroup" }
          },
          {
            width: 100,
            title: this.$t('generic.Action'),
            align: 'center',
            scopedSlots: { customRender: "operation" }
          },
          {
            title: this.$t('userlang.englishName'),
            dataIndex: "englishName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "englishName" }
          },
          {
            title: this.$t('userlang.sumplifiedName'),
            dataIndex: "simplifiedName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "simplifiedName" }
          },
          {
            title: this.$t('userlang.traditionalName'),
            dataIndex: "traditionalName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "traditionalName" }
          },
          {
            title: this.$t('userlang.koreanName'),
            dataIndex: "koreanName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "koreanName" }
          },
          {
            title: this.$t('userlang.thaiName'),
            dataIndex: "thaiName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "thaiName" }
          },
          {
            title: this.$t('userlang.japaneseName'),
            dataIndex: "japaneseName",
            width: 200,
            align: 'center',
            scopedSlots: { customRender: "japaneseName" }
          },
        ]
      },
      ...mapState(["uid"]) // 获取uid
    },
    watch: {
      uid(val) {
        if (val != "") {
          this.iniFreshTable();
        }
      }
    },
    mounted() {
      //滚动时
      this.$nextTick(() => {
        const scrollContainer = this.$refs.tableRef.$el.querySelector('.ant-table-body');
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', this.handleResize);
        }
      });
    },
    beforeDestroy() {
      //滚动时
      const scrollContainer = this.$refs.tableRef.$el.querySelector('.ant-table-body');
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handleResize);
      }
    },
    created() {
      this.getProjectCodeAndProjectList();
      this.handleResize();
      this.moduleList = this.allModuleList[this.selectedModuleCode]
    },
    methods: {
      saveSort() {
        let queryConditionSortVo = this.queryConditionList;
        ajax.post(api.SAVEQUERYCONDITIONSORT, queryConditionSortVo).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('cfs.operationSuccess'));
            this.iniFreshTable();
            this.selectedRowKeys = [];
          }
        });
      },
      arrowUp() {
        if (this.selectedRowKeys.length != 1) {
          this.$message.warning(this.$t('publicLang.pleaseOneOnly'));
          return;
        }
        let index = this.getIndexOfSel(this.selectedRowKeys[0]);
        if (index == 0) {
          return false;
        }
        let ab = this.queryConditionList;
        let temp = ab[index - 1];
        let SeqTemp1 = ab[index].seq;
        let seqTemp2 = ab[index - 1].seq;
        ab[index - 1].seq = SeqTemp1;
        ab[index].seq = seqTemp2;
        ab[index - 1] = ab[index];
        ab[index] = temp;
        this.queryConditionList = ab;
        this.selectedRowKeys = [ab[index - 1].seq];
        this.$forceUpdate();
      },
      arrowDown() {
        if (this.selectedRowKeys.length != 1) {
          this.$message.warning(this.$t('publicLang.pleaseOneOnly'));
          return;
        }
        let index = this.getIndexOfSel(this.selectedRowKeys[0]);
        let ii = parseInt(index) + 1;
        if (ii > this.queryConditionList.length - 1) {
          return false;
        }
        let ab = this.queryConditionList;
        let SeqTemp1 = ab[ii].seq;
        let seqTemp2 = ab[index].seq;
        ab[ii].seq = seqTemp2;
        ab[index].seq = SeqTemp1;

        let temp = ab[ii];
        ab[ii] = ab[index];
        ab[index] = temp;

        this.queryConditionList = ab;
        this.selectedRowKeys = [ab[ii].seq];
        this.$forceUpdate();
      },
      getIndexOfSel(val) {
        for (let ii in this.queryConditionList) {
          if (this.queryConditionList[ii].seq == val) {
            return ii;
          }
        }
      },
      deleteData() {
        if (this.checkRows.length > 0) {
          let deleteArray = [];
          for (let i in this.checkRows) {
            deleteArray.push(this.checkRows[i].uid);
          }
          let params = {
            gmcUid:this.uid,
            uids: deleteArray,
            projectCode:this.projectCode
          };
          ajax.post(api.DELETEQUERYCONDITION, params).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('cfs.operationSuccess'));
              this.iniFreshTable();
            }
          });
        } else {
          this.$message.warning(this.$t('publicLang.PleaseSltAtleast'));
        }
      },
      iniFreshTable(val) {
        let pagedbSelectList = this.pagedbSelectList;
        let schemaUids = [];
        if(val){
          for (let i in pagedbSelectList) {
            schemaUids.push(pagedbSelectList[i].schemaUid);
          }
        }
        let schemaParas = {
          schemaUids: schemaUids,
          uid: this.uid,
          projectCode:this.projectCode
        };
        if (this.uid === "") {
          return;
        }
        ajax.post(api.QUERYCONDITIONLIST, schemaParas).then(res => {
          this.queryConditionList = res.data;
          this.selectedRowKeys = [];
          this.checkRows = [];
          if(val){
            this.$emit("clearSelected");
          }
        });
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.checkRows = selectedRows;
      },
      addRowData() {
        this.queryTableName = '';
        this.headerTableName = '';
        this.detailTableName = '';
        this.addForm.resetFields();
        this.headerJoinNameList = []
        this.detailJoinNameList = []
        this.queryNameList = []
        this.showAdd = true;
        this.showCodeMasterGroup = false
        this.showFixedValue = false
      },
      editRowData(text) {
        this.queryTableName = '';
        this.headerTableName = '';
        this.detailTableName = '';
        this.editForm.resetFields();
        this.editData = text
        this.compareTypeSelect = this.compareTypeData[this.editData.pageType];
        if(this.editData.codeMasterGroup == null && this.editData.pageType != 'Dropdown'){
          this.showCodeMasterGroup = false
        }else {
          this.showCodeMasterGroup = true
        }
        if(this.editData.fixedValue != null && this.editData.pageType == 'Switch'){
          if (this.editData.compareType == 'is empty' || this.editData.compareType == 'is not empty') {
            this.showFixedValue = false;
          }else {
            this.showFixedValue = true;
          }
        }else {
          this.showFixedValue = false
        }
        // 让placeholder生效
        if(this.editData.headerJoinName == null){
          this.editData.headerJoinName = undefined
        }
        if(this.editData.detailJoinName == null){
          this.editData.detailJoinName = undefined
        }
        if(this.editData.queryName == null){
          this.editData.queryName = undefined
        }
        if(this.editData.schmUid == null){
          this.isAddData = true;
          this.headerJoinNameList = []
          this.detailJoinNameList = []
          this.queryNameList = []
          if(this.editData.headerModuleCode != undefined && this.editData.headerSubModuleCode != undefined){
            this.headerJoinNameModule(this.editData.headerSubModuleCode,false)
          }
          if(this.editData.detailModuleCode != undefined && this.editData.detailSubModuleCode != undefined){
            this.detailJoinNameModule(this.editData.detailSubModuleCode,false)
          }
          if(this.editData.queryModuleCode != undefined && this.editData.querySubModuleCode != undefined){
            this.queryNameModule(this.editData.querySubModuleCode,false)
          }
        }else {
          this.isAddData = false;
        }
        this.showEdit = true;
      },
      getModuleData(){
        ajax.get(api.QUERYMODULE).then(res => {
          this.moduleList = res.data;
        });
      },
      getCodeMasterGroup(){
        let params = {
          projectCode: this.projectCode,
        };
        ajax.get(api.GETCODEMASTERGROUP,params).then(res => {
          this.codeGroupList = res.data;
        });
      },
      getProjectCodeAndProjectList(){
        ajax.get(api.GETPROJECTCODEANDPROJECTLIST).then(res=>{
          this.projectCode = res.projectCode;
          this.tempProjectCode = res.projectCode;
          this.projectCodeList = res.projectCodeList;
          this.getCodeMasterGroup();
          this.iniFreshTable();
          // this.getModuleData();
        })
      },
      headerJoinNameModule(value,clear){
        if(clear){
          this.addForm.resetFields(['headerJoinName']);
          this.editForm.setFieldsValue({
            headerJoinName: undefined
          });
        }
        let params = {
          moduleCode: this.moduleList.moduleCode,
          subModuleCode: value
        }
        ajax.get(api.GETFIELDNAMEBYSCHEMA,params).then(res => {
          this.headerJoinNameList = res.data;
          this.selectHeaderTable()
        });
      },
      selectHeaderTable(){
        if(this.headerJoinNameList.length > 0){
          this.headerTableName = this.headerJoinNameList[0].TAB_NAME;
        }
      },
      detailJoinNameModule(value,clear){
        if(clear){
          this.addForm.resetFields(['detailJoinName']);
          this.editForm.setFieldsValue({
            detailJoinName: undefined
          });
        }
        let params = {
          moduleCode: this.moduleList.moduleCode,
          subModuleCode: value
        }
        ajax.get(api.GETFIELDNAMEBYSCHEMA,params).then(res => {
          this.detailJoinNameList = res.data;
          this.selectDetailTable()
        });
      },
      selectDetailTable(){
        if(this.detailJoinNameList.length > 0){
          this.detailTableName = this.detailJoinNameList[0].TAB_NAME;
        }
      },
      queryNameModule(value,clear){
        if(clear){
          this.addForm.resetFields(['queryName']);
          this.editForm.setFieldsValue({
            queryName: undefined
          });
          this.getInternationalLanguage({})
        }
        let params = {
          moduleCode: this.moduleList.moduleCode,
          subModuleCode: value
        }
        ajax.get(api.GETFIELDNAMEBYSCHEMA,params).then(res => {
          this.queryNameList = res.data;
        });
        this.autoFillJoin(params);
      },
      selectQueryTable(val){
        if(this.queryNameList.length > 0){
          this.queryTableName = this.queryNameList[0].TAB_NAME;
        }
        if(val.length == 1){//只获取第一个勾选的字段
          let item = this.queryNameList.find(item => item.FIELD_NAME === val[0]);
          let { moduleCodeQueryName } = this.showAdd ? this.addForm.getFieldsValue() : this.editForm.getFieldsValue();
          let params = {
            projectCode:this.projectCode,
            langCode: item.LANG_CODE,
            moduleCode:this.moduleList.moduleCode,
            subModuleCode:moduleCodeQueryName,
          };
          ajax.get(api.GETINTERNATIONALLANGUAGE,params).then(res => {
            this.getInternationalLanguage(res.data)
          });
        }
        if(val.length == 0){//清空
          this.getInternationalLanguage({})
        }
      },
      getInternationalLanguage(val){
        if(this.showAdd){
          this.addForm.setFieldsValue({
            englishName: val.englishName,
            simplifiedName: val.simplifiedName,
            traditionalName: val.traditionalName,
            koreanName: val.koreanName,
            thaiName: val.thaiName,
            japaneseName: val.japaneseName,
          });
        }else{
          this.editForm.setFieldsValue({
            englishName: val.englishName,
            simplifiedName: val.simplifiedName,
            traditionalName: val.traditionalName,
            koreanName: val.koreanName,
            thaiName: val.thaiName,
            japaneseName: val.japaneseName,
          });
        }
      },
      saveAddData() {
        this.addForm.validateFields((err, val) => {
          if(!err) {
            let params = {
              gmcUid : this.uid,
              pageType: val.pageType,
              headerTableName: this.headerTableName,
              headerJoinName: val.headerJoinName,
              detailTableName: this.detailTableName,
              detailJoinName: val.detailJoinName,
              queryTableName: this.queryTableName,
              queryName:  val.queryName.join(','),
              codeMasterGroup: val.codeMasterGroup,
              compareType: val.compareType,
              fixedValue: val.fixedValue,
              englishName: val.englishName,
              simplifiedName: val.simplifiedName,
              traditionalName: val.traditionalName,
              koreanName: val.koreanName,
              thaiName: val.thaiName,
              japaneseName: val.japaneseName,
              projectCode:this.projectCode,
            }
            ajax.post(api.SAVEQUERYCONDITION, params).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('cfs.operationSuccess'));
                this.showAdd = false;
                this.iniFreshTable();
                this.addForm.resetFields();
              }
            });
          }
        });
      },
      saveEditData() {
        this.editForm.validateFields((err, val) => {
          if(!err) {
            let params = val;
            params.gmcUid = this.uid;
            params.detailTableName = this.detailTableName;
            params.headerTableName = this.headerTableName,
                    params.queryTableName = this.queryTableName,
                    params.queryName = params.queryName.join(','),
                    params.moduleCodeHeaderJoinName = null;
            params.moduleCodeDetailJoinName = null;
            params.moduleCodeQueryName = null;
            params.projectCode = this.projectCode;
            ajax.post(api.SAVEQUERYCONDITION, params).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('cfs.operationSuccess'));
                this.showEdit = false;
                this.iniFreshTable();
                this.editData = {};
                this.editForm.resetFields();
              }
            });
          }
        });
      },
      selectedPageType(value){
        if(value == 'Dropdown'){
          this.showCodeMasterGroup = true;
          this.showFixedValue = false;
        }else{
          this.showCodeMasterGroup = false;
          this.showFixedValue = false;
        }
        if(this.showAdd){
          this.addForm.setFieldsValue({
            compareType: undefined,
          });
        }else{
          this.editForm.setFieldsValue({
            compareType: undefined,
          });
        }
        this.compareTypeSelect = this.compareTypeData[value];
      },
      selectedCompareType(value) {
        let { pageType } = this.showAdd ? this.addForm.getFieldsValue() : this.editForm.getFieldsValue();
        if(pageType == 'Switch'){
          this.showCodeMasterGroup = false;
          if (value == 'is empty' || value == 'is not empty') {
            this.showFixedValue = false;
          }else {
            this.showFixedValue = true;
          }
        }
      },
      changeProject(val){
        this.projectCode = val;
        this.tempProjectCode = val;
        this.iniFreshTable()
      },
      changeTabs(val){
        this.activeTab = val;
        if(val == 'project'){
          this.projectCode = this.tempProjectCode;
        }else if(val == 'default'){
          this.projectCode = '';
        }
        this.iniFreshTable();
        this.getCodeMasterGroup();
      },
      copyToProjectList() {
        if (this.checkRows.length == 0) {
          this.$message.warning(this.$t('publicLang.PleaseSltAtleast'));
          return;
        }
        let array = [];
        for (let i in this.checkRows) {
          array.push(this.checkRows[i].uid);
        }
        let params = {
          uids : array,
          gmcUid:this.uid,
          projectCode: this.tempProjectCode
        }
        ajax.post(api.COPYTOPROJECTLIST, params).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('cfs.operationSuccess'));
            this.changeTabs('project')
          }
        });
      },
      handleResize: throttle(function(event) {
        this.$nextTick(() => {
          if (this.$refs.refListTop) {
            this.windowHeight = window.innerHeight - this.$refs.refListTop.getBoundingClientRect().top - 5;
          }
        });
      }, 1000),
      copyNameToAnother(){
        if(this.showAdd){
          let {englishName} = this.addForm.getFieldsValue();
          this.addForm.setFieldsValue({
            simplifiedName: englishName,
            traditionalName: englishName,
            koreanName: englishName,
            thaiName: englishName,
            japaneseName: englishName,
          });
        }else{
          let {englishName} = this.editForm.getFieldsValue();
          this.editForm.setFieldsValue({
            simplifiedName: englishName,
            traditionalName: englishName,
            koreanName: englishName,
            thaiName: englishName,
            japaneseName: englishName,
          });
        }
      },
      showCopyProject(){
        if (this.checkRows.length == 0) {
          this.$message.warning(this.$t('publicLang.PleaseSltAtleast'));
          return;
        }
        this.projectForm.resetFields()
        this.showProject = true
      },
      copyToNewProject(){
        this.projectForm.validateFields((err, val) => {
          if (!err) {
            let array = [];
            for (let i in this.checkRows) {
              array.push(this.checkRows[i].uid);
            }
            let newProjectCode = this.projectForm.getFieldValue('newProjectCode')
            let params = {
              gmcUid: this.uid,
              uids:array,
              projectCode: newProjectCode
            }
            ajax.post(api.COPYTONEWPROJECT, params).then(res => {
              if (res.code === 200) {
                this.projectCode = newProjectCode
                this.tempProjectCode = newProjectCode
                this.showProject = false
                this.$message.success(this.$t('cfs.operationSuccess'));
                this.iniFreshTable();
              }
            });
          }
        });
      },
      autoFillJoin(params){
        let moduleCodeDetailJoinName = undefined
        let detailJoinName = undefined
        let moduleCodeHeaderJoinName = undefined
        let headerJoinName = undefined
        if(params.moduleCode == 'ASN' && params.subModuleCode != 'ASN_HEADER'){
          moduleCodeDetailJoinName = params.subModuleCode
          detailJoinName = 'ASN_HEADER_UID'
          moduleCodeHeaderJoinName = "ASN_HEADER"
          headerJoinName = 'UID'
        }else if(params.moduleCode == 'SO' && params.subModuleCode != 'SO_HEADER'){
          moduleCodeDetailJoinName = params.subModuleCode
          detailJoinName = 'SO_HEADER_UID'
          moduleCodeHeaderJoinName = "SO_HEADER"
          headerJoinName = 'UID'
        }
        if(this.showAdd){
          this.addForm.setFieldsValue({
            moduleCodeDetailJoinName: moduleCodeDetailJoinName,
            detailJoinName: detailJoinName,
            moduleCodeHeaderJoinName: moduleCodeHeaderJoinName,
            headerJoinName: headerJoinName
          });
        }else {
          this.editForm.setFieldsValue({
            moduleCodeDetailJoinName: moduleCodeDetailJoinName,
            detailJoinName: detailJoinName,
            moduleCodeHeaderJoinName: moduleCodeHeaderJoinName,
            headerJoinName: headerJoinName
          });
        }
        if(moduleCodeDetailJoinName != undefined){
          this.detailJoinNameModule(moduleCodeDetailJoinName,false)
        }
        if(moduleCodeHeaderJoinName != undefined){
          this.headerJoinNameModule(moduleCodeHeaderJoinName,false)
        }
      },
    }
  };
</script>
<style lang="less" scoped>
  #pageProperty {
    margin-top: 0px;
  }
  .pageProperty-btn {
    margin-top: 10px;
  }
</style>
